import RuntimeUtils from '../system/RuntimeUtils';
import WindowUtils from '../browser/WindowUtils';
if (RuntimeUtils.isBrowser()) {
    window.scrollToV = WindowUtils.scrollToV;
}
//# sourceMappingURL=WindowExtensions.js.map